
export type BrsTextBoxOptions = {
	delay?: number;
} & kendo.ui.TextBoxOptions;

export class BrsTextBoxWidget extends kendo.ui.TextBox {
	override events = ['keyup'];
	private debounceTimer: ReturnType<typeof setTimeout> = setTimeout(() => '', 1000);

	constructor(element: Element, options?: BrsTextBoxOptions) {
		super(element, {prefixOptions: {template: ''}, suffixOptions: {template: ''}, ...options});
		options ||= {};
		options.delay ||= 500;
		this.options = {...this.options, ...options};
		this.element.on('keyup', this._debounce(this._keyup.bind(this), 600));
	}

	// eslint-disable-next-line @typescript-eslint/ban-types
	private _debounce(function_: Function, delay: number) {
		// eslint-disable-next-line unicorn/prevent-abbreviations
		return (...args: any[]) => {
			clearTimeout(this.debounceTimer);
			// eslint-disable-next-line @typescript-eslint/no-unsafe-return
			this.debounceTimer = setTimeout(() => Reflect.apply(function_, this, args), delay);
		};
	}

	private _keyup() {
		this.value(this.element.val() as string);
		this.trigger('change');
	}
}

declare global {
	// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
	interface JQuery {
		kendoBrsTextBoxWidget(options?: BrsTextBoxOptions): JQuery;
		data(widgetName: 'kendoBrsTextBoxWidget'): BrsTextBoxWidget;
	}
}

kendo.ui.plugin(BrsTextBoxWidget);
